<template>
    <div class="card mb-xl-4 mb-1" v-if="Lobby">
        <div class="card-header">
            <h4><i class="far fa-user"></i> In der Lobby: {{Lobby.counter()}}</h4>
        </div>
        <div class="card-body pt-xl-2 pb-xl-2 pt-1 pb-1 pl-0 pr-0">
            <table class="table table-sm table-striped">
                <tbody>
                    <tr v-for="user in Lobby.users" :key="user.id">
                        <td class="w-60">
                            <player-card :player="user.player" :user="user"/>
                        </td>
                        <td class="w-40"><a :href="'/matchrequests/create/' + user.id" class="btn btn-sm btn-primary btn-block">Herausfordern</a></td>
                    </tr>
                </tbody>
            </table>
        </div>
    </div>
</template>

<script>
    export default {
        data() {
            return {
                Lobby: null
            }
        },
        mounted() {
            console.log('Component mounted.')
            this.Lobby = window.Lobby;
        }
    }
</script>
